var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownArrowHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29979 0.175334C0.954776 -0.100673 0.451342 -0.0447361 0.175334 0.300273C-0.100673 0.645283 -0.0447361 1.14872 0.300273 1.42472L5.17533 5.32477C5.54055 5.61695 6.05951 5.61695 6.42472 5.32477L11.2998 1.42472C11.6448 1.14872 11.7007 0.645283 11.4247 0.300273C11.1487 -0.0447361 10.6453 -0.100673 10.3003 0.175334L6.42472 3.27577C6.05951 3.56795 5.54055 3.56795 5.17533 3.27577L1.29979 0.175334Z",
    fill: "#7872B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowHover);
export default __webpack_public_path__ + "static/media/dropdown-arrow_hover.08148391fecf2b4954cce5013fbe9a42.svg";
export { ForwardRef as ReactComponent };